import {
  PayOverTimeDownloadStatementResultTypenames,
  Query,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import PayOverTimeStatement from 'services/graphql/queries/PayOverTimeStatement';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const usePayOverTimeStatement = (documentId: string) => {
  const router = useRouter();
  const [{ data, fetching: loading, error }, refetchPayOverTimeStatement] =
    useQuery<Query>({
      query: PayOverTimeStatement,
      variables: {
        input: {
          documentId,
        },
      },
      pause: !documentId,
      requestPolicy: 'network-only',
    });

  const result = data?.payOverTimeStatement;
  const statement =
    result?.__typename ===
    PayOverTimeDownloadStatementResultTypenames.PayOverTimeDownloadStatementSuccess
      ? result.statement
      : null;
  const resultError =
    result?.__typename ===
    PayOverTimeDownloadStatementResultTypenames.PayOverTimeDownloadStatementError
      ? result
      : null;

  const refresh = () => {
    refetchPayOverTimeStatement();
  };

  const cancel = () => {
    router.back();
  };

  const { defaultTitle, defaultMessage, retryButtonTitle, cancelButtonTitle } =
    useDefaultErrorStrings();
  const responseError = useFormattedCombinedError(error);

  const errorModel =
    error || resultError
      ? {
          screenType: ErrorScreenType.Error,
          messageHeadline:
            resultError?.title ?? responseError?.title ?? defaultTitle,
          messageBody:
            resultError?.message ?? responseError?.message ?? defaultMessage,
          primaryButton: {
            title: retryButtonTitle,
            onPress: refresh,
          },
          secondaryButton: {
            title: cancelButtonTitle,
            onPress: cancel,
          },
        }
      : null;

  return {
    statement,
    errorModel,
    loading,
    refresh,
  };
};

export default usePayOverTimeStatement;
